import React, { useEffect, useState } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import useEffectAsync from '../../../../utilities/hooks/useEffectAsync';
import { connect } from 'react-redux';
import { goToPage, setSelectedTab, setSelectedPackage, clearSelection, reportDWH, reportAnalytics } from '../PremiumPackagesCatalogSlice';
import { getCatalogAsync } from '../premiumPackagesCatalogAsyncThunk';
import PackagesTabs from '../Partials/packagesTabs/packagesTabs';
import PackageBoxList from '../Partials/packageBoxList/packageBoxList';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import { setCurrentProcess, setSelectedTvSubscriber, setRegistrationParams } from '../../StreamingRegistrationRedirectionBlock/StreamingRegistrationSlice';
import { StreamingRegistrationProcessTypes, DISNEY_REGISTRATION_PARAMS, HBO_REGISTRATION_PARAMS } from '../../StreamingRegistrationRedirectionBlock/utils/constants';
import Config from 'app/Config';

const PackagesPage = (props) => {

    useEffect(() => {
        if (props.isStateReset) {
            props.getCatalogAsync();
        }
    }, [props.isStateReset]);

    useExtendedEffect((runSideEffects) => {
        props.reportDWH({ actionType: 'Packages List Page', status: 'Ongoing', messageText: 'Sale Packages List Displayed' });
        if (props.installedPackages?.length > 0) {
            props.reportAnalytics({
                eventCategory: 'premium_packages',
                eventAction: 'visibility_3',
                eventLabel: props.installedPackages?.length.toString(),
            });
        }
        else {
            props.reportAnalytics({
                eventCategory: 'premium_packages',
                eventAction: 'visibility_10',
                eventLabel: 'element_12',
            });
        }
        if (runSideEffects()) {

        }
    }, []);

    let purpleTitle = `${window.Config.brand_Name_HE} TV`;
    let boldTitle1 = "שדרגו את חווית הצפייה שלכם";
    let boldTitle2 = "";
    let extraBoldTitle = "";
    let subTitle = props.installedPackages.length == 0 ? "בחרו חבילה שתרצו להוסיף" : "";

    let formid = 'premiumPackagesCatalogForm';

    let currentPageHeadline = (
        <div className='page-headline-wrapper'>
            {purpleTitle && <h1 className='purple-title'>{purpleTitle}</h1>}
            {boldTitle1 && <h2 className='bold-title1'> {boldTitle1} </h2>}
            {boldTitle2 && <h2 className='bold-title2'> {boldTitle2} </h2>}
            {extraBoldTitle && <h3 className='extra-bold-title'> {extraBoldTitle} </h3>}
            {subTitle && <h4 className='sub-title'> {subTitle} </h4>}
        </div>

    );

    const premiumPackagesByGroups = props.availablePackages.reduce((groups, item) => {
        if (!item.cmsData?.selfCare?.existedPackageOnly) {
            const categories = item.cmsData?.categories;
            categories?.map(function (category, i) {
                var categoryName = category.categoryName;
                if (!groups[categoryName]) {
                    groups[categoryName] = [];
                }
                groups[categoryName].push(item);
            });
        }
        return groups;
    }, {});

    let currentPageView = (<>
        {props.installedPackages?.length > 0 && <PackagesTabs selectedTab={props.selectedTab} onSelectedTab={handleOnSelectedTab} />}
        <PackageBoxList defaultImage={props.defaultImage} selectedTab={props.selectedTab} premiumPackagesByGroups={premiumPackagesByGroups} availablePackages={props.availablePackages} installedPackages={props.installedPackages} onClickPackage={handleOnClickPackage} onHboRegistrationClick={handleHboRegistrationClick} onDisneyRegistrationClick={handleDisneyRegistrationClick} />
    </>);

    return (
        <div>
            {currentPageHeadline}
            <div className='premium-packages-catalog-content'>
                <form noValidate id={formid} onSubmit={handleSubmit}>
                    {currentPageView}
                </form>
            </div>
        </div>
    );

    function handleSubmit(event) {
        event.preventDefault();
    }

    function handleHboRegistrationClick() {
        props.setRegistrationParams(HBO_REGISTRATION_PARAMS);
        props.setCurrentProcess(StreamingRegistrationProcessTypes.PACKAGE_EXIST);
        props.setSelectedTvSubscriber(props.selectedSubscriber?.subscriberNo);
        props.context.navigateTo(Config.redirectToHboUrl);
    }

    function handleDisneyRegistrationClick() {
        props.setRegistrationParams(DISNEY_REGISTRATION_PARAMS);
        props.setCurrentProcess(StreamingRegistrationProcessTypes.PACKAGE_EXIST);
        props.setSelectedTvSubscriber(props.selectedSubscriber?.subscriberNo);
        props.context.navigateTo(Config.redirectToDisneyUrl);
    }

    function handleOnSelectedTab(tabName) {
        props.setSelectedTab(tabName);
        if (tabName == "existingPackages") {
            props.reportDWH({ actionType: 'Packages List Page', status: 'Ongoing', messageText: 'Existing Packages List Displayed' });
            props.reportAnalytics({
                eventCategory: 'premium_packages',
                eventAction: 'click_4',
                eventLabel: 'element_6',
            });
        }
    }

    function handleOnClickPackage(premiumPackage) {
        props.clearSelection();
        props.setSelectedPackage(premiumPackage);
        if (props.selectedTab == "newPackages") {
            props.reportAnalytics({
                eventCategory: 'premium_packages',
                eventAction: 'click_13',
                eventLabel: premiumPackage.cmsData?.selfCare?.title ? premiumPackage.cmsData.selfCare.title : premiumPackage.localizedName
            });
            if (premiumPackage.isPremiumPackagesWorld) {
                props.goToPage('packagesWorldPage');
            }
            else if (premiumPackage.vasList?.length > 0) {
                props.goToPage('packageRoutesPage');
            }
            else {
                props.goToPage('packageBasicPage');
            }
        }
        else {
            props.reportAnalytics({
                eventCategory: 'premium_packages',
                eventAction: 'click_5',
                eventLabel: premiumPackage.cmsData?.selfCare?.title ? premiumPackage.cmsData.selfCare.title : premiumPackage.localizedName
            });
            props.goToPage('packageExistPage');
        }
    }

};

const mapStateToProps = (state) => {
    return {
        selectedTab: state.premiumPackagesCatalog.selectedTab,
        installedPackages: state.premiumPackagesCatalog.installedPackages,
        availablePackages: state.premiumPackagesCatalog.availablePackages,
        premiumPackagesWorlds: state.premiumPackagesCatalog.premiumPackagesWorlds,
        defaultImage: state.premiumPackagesCatalog.epiData?.defaultImage,
        action: state.premiumPackagesCatalog.action,
        selectedSubscriber: state.premiumPackagesCatalog.selectedSubscriber,
        isStateReset: state.stateHistory.isStateReset,
    };
};

const mapDispatchToProps = {
    setSelectedTab,
    setSelectedPackage,
    goToPage,
    clearSelection,
    reportDWH,
    reportAnalytics,
    showAppLoader,
    hideAppLoader,
    setCurrentProcess,
    setSelectedTvSubscriber,
    setRegistrationParams,
    getCatalogAsync,
};

export default connect(mapStateToProps, mapDispatchToProps)(PackagesPage);
